//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import Stores from '~/views/MerchantsStores/Stores/Table.vue';

export default {
  components: {
    Stores,
  },

  async mounted() {
    this.setGeneralLoader(true);
    await Promise.allSettled([
      this.load(),
    ]);
    this.setGeneralLoader(false);
  },

  methods: {
    ...mapActions('common', ['setGeneralLoader']),
    ...mapActions('merchantsStores', {
      load: 'loadData',
    }),
  },
};
